import { __decorate } from "tslib";
import { Component } from 'decorators';
import BuilderSecondColumnSidebarView from './builderSecondCollumnSidebarView.html';
import './builderSecondCollumnSidebar.scss';
let BuilderSecondColumnSidebarComponent = class BuilderSecondColumnSidebarComponent {
    $onInit() {
        this.width = this.width || '460px';
    }
    closeSidebar() {
        if (this.onClose) {
            this.onClose();
        }
    }
};
BuilderSecondColumnSidebarComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: BuilderSecondColumnSidebarView,
        bindings: {
            header: '@',
            link: '@?',
            description: '@',
            onClose: '&',
            width: '@?',
        },
        transclude: true,
    })
], BuilderSecondColumnSidebarComponent);
export { BuilderSecondColumnSidebarComponent };
